import { Pipe, PipeTransform } from '@angular/core';
import { brand } from '../Model/brand';

@Pipe({
  name: 'brandsFilter',
  standalone: false
})
export class BrandsFilterService implements PipeTransform {

  transform(brands: brand[], searchTerm: string, field?: string): brand[] {
    if (!brands || !searchTerm?.trim()) {
      return brands;
    }

    const lowerSearch = searchTerm.toLowerCase();

    return brands.filter(b =>
      field && b[field]
        ? String(b[field]).toLowerCase().includes(lowerSearch)
        : b.brandName.toLowerCase().includes(lowerSearch)
    );
  }
}
